/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Quote({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M.34 4.1c0-.972.788-1.76 1.76-1.76h3.3c.972 0 1.76.788 1.76 1.76v3.356a1.76 1.76 0 0 1-1.76 1.76H1.72a3.64 3.64 0 0 0 3.216 2.963l1.63.164a.66.66 0 1 1-.132 1.314l-1.631-.165A4.96 4.96 0 0 1 .34 8.556zm1.32 3.796H5.4a.44.44 0 0 0 .44-.44V4.1a.44.44 0 0 0-.44-.44H2.1a.44.44 0 0 0-.44.44zM8.84 4.1c0-.972.788-1.76 1.76-1.76h3.3c.972 0 1.76.788 1.76 1.76v3.356a1.76 1.76 0 0 1-1.76 1.76h-3.68a3.64 3.64 0 0 0 3.216 2.963l1.63.164a.66.66 0 0 1-.132 1.314l-1.631-.165A4.96 4.96 0 0 1 8.84 8.556zm1.32 3.796h3.74a.44.44 0 0 0 .44-.44V4.1a.44.44 0 0 0-.44-.44h-3.3a.44.44 0 0 0-.44.44z" clipRule="evenodd" /></svg>;
}
;